import { FlyoutFunction } from '../../types/marketplace'

export const getFlyOutFunctionTypeBasedOnUrl = ({
  pathname,
}: {
  pathname: string
}): FlyoutFunction | '' => {
  if (pathname.includes('private-offers')) {
    return FlyoutFunction.PRIVATE_OFFERS
  }
  if (pathname.includes('resale-authorizations')) {
    return FlyoutFunction.RESALE_AUTHORIZATIONS
  }
  if (pathname.includes('revenue')) {
    return FlyoutFunction.REVENUE
  }
  if (pathname.includes('subscriptions')) {
    return FlyoutFunction.SUBSCRIPTION
  }
  return ''
}
